export default {
  appointmentLink: "https://cal.com/fuchsjobs",
};
